module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login-form"
  }, [(_vm.productImage) ? _c('div', [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": _vm.UPLOAD_DOMAIN + _vm.productImage
    }
  })]) : _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./logo.png")
    }
  })]), _vm._v(" "), _c('group', [_c('x-input', {
    attrs: {
      "title": "手机号",
      "name": "mobile",
      "placeholder": "请输入手机号码",
      "keyboard": "number",
      "is-type": "china-mobile"
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "验证码",
      "name": "smsCode",
      "keyboard": "number",
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.smsCode),
      callback: function($$v) {
        _vm.smsCode = $$v
      },
      expression: "smsCode"
    }
  }, [(_vm.countingNumber) ? _c('x-button', {
    attrs: {
      "slot": "right",
      "type": "primary",
      "disabled": "",
      "mini": ""
    },
    slot: "right"
  }, [_vm._v("发送 (" + _vm._s(_vm.countingNumber) + ")")]) : _c('x-button', {
    attrs: {
      "slot": "right",
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.sendSMSCode($event)
      }
    },
    slot: "right"
  }, [_vm._v("发送")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.mobileNumber || !_vm.smsCode
    },
    nativeOn: {
      "click": function($event) {
        return _vm.smsLogin($event)
      }
    }
  }, [_vm._v("确定")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ff13d3"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/smsLogin.vue
// module id = 544
// module chunks = 0